document.addEventListener('DOMContentLoaded', function () {

    function isHidden(el) {
        return !el || el.classList.contains('hidden-item');
    }

    function LoadMoreFaq(faqsList) {
        var listItems = Array.from(faqsList.querySelectorAll('.faqs-list li'));
        var hiddenItems = listItems.filter(isHidden);
        var limit = Math.min(hiddenItems.length, 6);

        for (var i = 0; i < limit; i++) {
            var it = hiddenItems[i];
            if (it) it.classList.remove('hidden-item');
        }

        var stillHidden = listItems.filter(isHidden).length;
        if (stillHidden < 1) {
            var btn = faqsList.querySelector('.faqs-load-more');
            if (btn) btn.classList.add('disabled');
        }
    }

    document.querySelectorAll('.faqs').forEach(function (faqsElem) {
        var faqsList = faqsElem;

        // Hide all the FAQs to begin with
        faqsList.querySelectorAll('.faqs-list li').forEach(function (li) { li.classList.add('hidden-item'); });

        // Show initial batch
        var listItems = Array.from(faqsList.querySelectorAll('.faqs-list li'));
        var limit = Math.min(listItems.filter(isHidden).length, 6);
        listItems.slice(0, limit).forEach(function (li) { li.classList.remove('hidden-item'); });

        // Click handler for load more
        var btn = faqsList.querySelector('.faqs-load-more');
        if (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                LoadMoreFaq(faqsList);
            });
        }
    });

});



